import { size, remove } from "lodash";
import { authFetch } from "../utils/fetch";
import { CART, BASE_PATH } from "../utils/constants";

export async function isCartItemApi(userId, productId, auth) {
  // &usuario=7&productos=4
  try {
    // const url = `${BASE_PATH}/api/cart-items?filters[usuario][id]=${userId}&populate[productos][populate]=*&publicationState=preview&filters[productos][id]=${productId}`;
    const url = `${process.env.REACT_APP_API_URL}/api/cart-items?where[user][equals]=${userId}&where[product][equals]=${productId}`;
    return await authFetch(url, null, auth);
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getProductsCart(userId, logout) {
  // if (!cart) {
  //   return null;
  // } else {
  //   const products = cart.split(",");
  //   return products;
  // }
  // console.log(userId);
  try {
    const sortItem = "sort=createdAt:asc";
    const url = `${process.env.REACT_APP_API_URL}/api/cart-items?where[user][equals]=${userId}&depth=1`;

    // const url = `${BASE_PATH}/api/cart-items?${sortItem}&filters[usuario][id]=${userId}&publicationState=preview&populate[productos][populate]=*`;
    const response = await authFetch(url, logout);
    // console.log(response);
    // const result = await response.json();
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function addProductCart(product, quantity, logout) {
  // delete product.attributes.createdAt;
  // delete product.attributes.updatedAt;
  // delete product.attributes.publishedAt;
  const { id: productId } = product;
  // console.log(product, "ADD PRODUCT CART");
  const productData = {
    data: {
      productos: [productId],
      cantidad: quantity,
      usuario: logout.idUser,
    },
  };

  // console.log(logout, "user");
  try {
    const dataFound = await isCartItemApi(logout.idUser, productId, logout);
    // console.log(dataFound.data);
    if (size(dataFound.data) > 0 || !dataFound) {
      if (
        dataFound.data[0].attributes.productos.data[0].attributes.stock >=
        quantity &&
        dataFound.data[0].attributes.cantidad + quantity <=
        dataFound.data[0].attributes.productos.data[0].attributes.stock
      ) {
        const url = `${process.env.REACT_APP_API_URL}/api/cart-items/${dataFound.data[0].id}`;
        const params = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              productos: [productId],
              cantidad: quantity + dataFound.data[0].attributes.cantidad,
              usuario: logout.idUser,
            },
          }),
        };
        const result = await authFetch(url, params, logout);
        // console.log("Producto añadido al carrito");
        // TO-DO: ALERT CONTEXT
        // console.log("Es menor y se agregó");
        return result;
      } else {
        // TO-DO: ALERT CONTEXT
        console.log("no se agregó");
      }
    } else {
      const data = JSON.stringify(productData);
      const url = `${process.env.REACT_APP_API_URL}/api/cart-items`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      };
      const result = await authFetch(url, params, logout);
      // console.log("Producto añadido al carrito");
      return result;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
  // const cart = getProductsCart();
  // if (!cart) {
  //   // localStorage.setItem(CART, JSON.stringify(product));
  //   const productData = {
  //     data: { productos: productId, cantidad: 3, usuario: 6 },
  //   };
  //   const data = JSON.stringify(productData);
  //   console.log(data);
  // } else {
  //   console.log("Este producto ya esta en el carrito");
  // const productFound = includes(cart, JSON.stringify(product));
  // if (productFound) {
  //   console.log("Este producto ya esta en el carrito");
  // } else {
  //   cart.push(product);
  //   localStorage.setItem(CART, cart);
  //   console.log("Producto añadido correctamente");
  // }
  // }
}

export async function addToCart(product, quantity, auth) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/cart-items?where[user][equals]=${auth.idUser}&where[product][equals]=${product.id}`;

    const response = await fetch(url);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to fetch cart items");
    }

    if (data.docs.length > 0) {
      // Item exists, update quantity
      const cartItem = data.docs[0];
      const updatedQuantity = cartItem.quantity + quantity;

      const updateResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/cart-items/${cartItem.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth.token}`,
          },
          body: JSON.stringify({ quantity: updatedQuantity }),
        }
      );

      const updatedItem = await updateResponse.json();

      if (!updateResponse.ok) {
        throw new Error(updatedItem?.message || "Failed to update cart item");
      }

      return { success: true, action: "updated", data: updatedItem };
    } else {
      // Item does not exist, create a new cart item
      const createResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/cart-items`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth.token}`,
          },
          body: JSON.stringify({
            user: auth.idUser,
            product: product.id,
            quantity,
          }),
        }
      );

      const newItem = await createResponse.json();

      if (!createResponse.ok) {
        throw new Error(newItem?.message || "Failed to create cart item");
      }

      return { success: true, action: "created", data: newItem };
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    return { success: false, error: error.message };
  }
}

export async function increaseProductCart(userId, quantity, productId, auth) {
  // console.log(productId);

  try {
    const dataFound = await isCartItemApi(userId, productId, auth);
    if (dataFound?.docs?.length > 0) {
      const cartItem = dataFound.docs[0]; // Get first matching item
      const updatedQuantity = Math.max(cartItem.quantity + 1, 0);
      const url = `${process.env.REACT_APP_API_URL}/api/cart-items/${cartItem.id}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth ? auth.token : ""}`, // Use auth.token instead of logout.token
        },
        body: JSON.stringify({ quantity: updatedQuantity }), // Only update quantity
      };

      const result = await authFetch(url, params, auth);
      // console.log(result, "result 242");
      if (!result.doc) {
        throw new Error(result?.message || "Failed to increaseProduct");
      }
      return { success: true, action: "increased", data: result };
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
export async function decreaseProductCart(userId, quantity, productId, auth) {
  try {
    // Find the cart item first
    const dataFound = await isCartItemApi(userId, productId, auth);

    if (dataFound?.docs?.length > 0) {
      const cartItem = dataFound.docs[0]; // Get first matching item
      const updatedQuantity = Math.max(cartItem.quantity - 1, 0);
      const url = `${process.env.REACT_APP_API_URL}/api/cart-items/${cartItem.id}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth ? auth.token : ""}`, // Use auth.token instead of logout.token
        },
        body: JSON.stringify({ quantity: updatedQuantity }), // Only update quantity
      };

      const result = await authFetch(url, params, auth);
      // console.log(result, "result 242");
      if (!result.doc) {
        throw new Error(result?.message || "Failed to drecreaseProduct");
      }
      return { success: true, action: "decreased", data: result };
    }
  } catch (error) {
    console.error("Error decreaseing in cart:", error);
    return { success: false, error: error.message };
  }
}

export async function getTotalCartPrice(userId, logout) {
  try {
    const cart = await getProductsCart(userId, logout);
    if (!cart.data) {
      return 0;
    } else {
      // console.log(size(cart.data));
      const amount = cart.data.reduce(function (tally, cartItem) {
        // console.log(cartItem);
        return (
          tally +
          cartItem?.attributes.cantidad *
          cartItem?.attributes.productos.data[0]?.attributes.precio
        );
      }, 0);
      // console.log(amount);
      return amount;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function countProductsCart(userId, logout) {
  try {
    const cart = await getProductsCart(userId, logout);
    if (!cart.data) {
      return 0;
    } else {
      const itemCount = cart.data.reduce(
        (total, product) => total + product.attributes.cantidad,
        0
      );
      // console.log(itemCount, "itemCount");
      return itemCount;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function deleteCartItemApi(userId, productId, auth) {
  try {
    const dataFound = await isCartItemApi(userId, productId, auth);
    if (dataFound?.docs?.length > 0) {
      const cartItemId = dataFound.docs[0].id; // Get the cart item ID

      const url = `${process.env.REACT_APP_API_URL}/api/cart-items/${cartItemId}`;
      const params = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth ? auth.token : ""}`, // Use auth.token instead of logout.token
        },
      };

      const result = await authFetch(url, params, auth);
      console.log('Delete cart item result:', result);

      if (!result.doc) {
        throw new Error(result?.message || "Failed to delete cart item");
      }
      return { success: true, action: "deleted", data: result };
    } else {
      return { success: false, error: "Cart item not found" };
    }
  } catch (error) {
    console.log('Delete cart item error:', error);
    return null;
  }
}

export function removeProductCart(product) {
  const cart = getProductsCart();

  remove(cart, (item) => {
    return item === product;
  });

  if (size(cart) > 0) {
    localStorage.setItem(CART, cart);
  } else {
    localStorage.removeItem(CART);
  }
}

export async function paymentCartApi(token, products, idUser, address, logout) {
  try {
    const addressShipping = address;
    delete addressShipping.user;
    delete addressShipping.createdAt;

    const url = `${process.env.REACT_APP_API_URL}/orders`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        products,
        idUser,
        addressShipping,
      }),
    };
    const result = await authFetch(url, params, logout);
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function removeAllProductsCart(userId, auth) {
  try {
    // First, get all cart items for the user
    const userCartItems = await getProductsCart(userId, auth);

    if (userCartItems?.docs && userCartItems.docs.length > 0) {
      // Delete each cart item individually
      const deletePromises = userCartItems.docs.map(async (cartItem) => {
        const url = `${process.env.REACT_APP_API_URL}/api/cart-items/${cartItem.id}`;
        const params = {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth ? auth.token : ""}`,
          },
        };
        return authFetch(url, params, auth);
      });

      // Wait for all deletions to complete
      await Promise.all(deletePromises);
      return { success: true, message: "All cart items deleted successfully" };
    } else {
      return { success: true, message: "No cart items to delete" };
    }
  } catch (error) {
    console.log(error);
    return { success: false, error: error.message };
  }
}
